import "./ModalWindow.css";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faXmark} from "@fortawesome/free-solid-svg-icons";

export default function ModalWindow({children, className="", handleClose}) {
    return (
        <div className="modal">
            <div className={`${className} modal-content`}>
                <button className="close-modal-button" onClick={handleClose}>
                    <FontAwesomeIcon icon={faXmark}/>
                </button>
                {children}
            </div>
        </div>);
}